import { render, staticRenderFns } from "./NewsBlock.vue?vue&type=template&id=f1b0e52c&scoped=true&"
import script from "./NewsBlock.vue?vue&type=script&lang=js&"
export * from "./NewsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b0e52c",
  null
  
)

export default component.exports